module.exports = __webpack_public_path__ + "img/vitamine_locale.d3d5f844.svg";